import gql from 'graphql-tag';

export const GET_VOV_CMS_BUTTON = gql`
  query vovCmsButton {
    cms {
      page(siteId: "discountTire", id: "/buy-wheels") {
        contentSlots {
          cmsComponents {
            name
            ... on CmsHtmlComponent {
              html
            }
          }
        }
      }
    }
  }
`;
